<!-- TEMPLATE CONTRACT: Ui Sidebar Component owns the visible Angular template structure for src/app/shared/ui/ui-sidebar/ui-sidebar.component.html. -->
<aside class="ui-sidebar" [class.ui-sidebar--collapsed]="collapsed()">
  <header class="ui-sidebar__brand">
    <div class="ui-sidebar__brand-main">
      <button
        type="button"
        class="brand-mark"
        [class.brand-mark--clickable]="collapsed()"
        [attr.aria-label]="collapsed() ? ('sidebar.actions.expand' | translate) : ('sidebar.actions.logo' | translate)"
        (click)="onLogoClick()"
      >
        <img class="brand-mark__image" src="assets/images/brand/palladium-movendi-mark.png" alt="" />
      </button>
      <div class="brand-text">
        <img class="brand-logo" src="assets/images/brand/palladium-movendi-logo.png" [alt]="'brand.logoAlt' | translate" />
      </div>
    </div>
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (!collapsed()) {
      <button
        type="button"
        class="ui-sidebar__collapse-btn"
        (click)="toggleCollapsed()"
        [attr.aria-label]="'sidebar.actions.collapse' | translate"
        aria-controls="sidebar-nav"
        [attr.aria-expanded]="true"
      >
        <span class="material-symbols-rounded" aria-hidden="true">keyboard_arrow_left</span>
      </button>
    }
  </header>

  <nav class="ui-sidebar__nav" id="sidebar-nav">
    <!-- Repeated block documents how collection data renders in the UI. -->
    @for (item of items(); track trackNavItem(item)) {
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (item.children?.length) {
        <div class="ui-sidebar__group">
          <button
            type="button"
            class="ui-sidebar__item ui-sidebar__item--group-parent"
            [attr.title]="collapsed() ? (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate)) : null"
            [attr.aria-expanded]="isGroupExpanded(item.path)"
            (click)="onGroupParentClick(item.path)"
          >
            <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(item) }}</span>
            <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
          </button>
          <button
            type="button"
            class="ui-sidebar__group-toggle"
            [attr.aria-label]="('sidebar.actions.toggle' | translate) + ' ' + (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate))"
            (click)="toggleGroup(item.path)"
            [attr.aria-expanded]="isGroupExpanded(item.path)"
          >
            <span class="material-symbols-rounded" [class.ui-sidebar__arrow--open]="isGroupExpanded(item.path)">
              keyboard_arrow_down
            </span>
          </button>
        </div>
        <!-- Conditional branch documents the visible UI state for this condition. -->
        @if (isGroupExpanded(item.path) && !collapsed()) {
          <!-- Repeated block documents how collection data renders in the UI. -->
          @for (child of item.children; track trackNavItem(child)) {
            <a
              class="ui-sidebar__item ui-sidebar__item--child"
              routerLinkActive="is-active"
              [routerLink]="child.path"
              [queryParams]="child.queryParams"
              [routerLinkActiveOptions]="childActiveMatchOptions"
            >
              <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(child) }}</span>
              <span class="ui-sidebar__label">{{ child.labelKey ? (child.labelKey | translate) : (child.label | uiLabelTranslate) }}</span>
            </a>
          }
        }
      } @else {
        <a
          class="ui-sidebar__item"
          routerLinkActive="is-active"
          [routerLink]="item.path"
          [queryParams]="item.queryParams"
          [routerLinkActiveOptions]="topLevelActiveMatchOptions"
          [attr.title]="collapsed() ? (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate)) : null"
        >
          <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(item) }}</span>
          <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
        </a>
      }
    }
  </nav>

  <footer class="ui-sidebar__footer">
    <div class="user-avatar">
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (user().avatar) {
        <img
          class="user-avatar__image"
          [class.user-avatar__image--loaded]="isAvatarLoaded(user().avatar)"
          [src]="user().avatar"
          alt=""
          (load)="onAvatarLoaded()"
          (error)="onAvatarError()"
        />
      }
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (!isAvatarLoaded(user().avatar)) {
        {{ user().initials }}
      }
    </div>
    <div class="user-meta">
      <strong>{{ user().name }}</strong>
      <span>{{ user().role | translate }}</span>
    </div>
  </footer>
</aside>
